//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('deviations', {
//        templateUrl: 'views/components/views/deviations/deviations.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'deviationsService', function ($stateParams, stateService, deviationsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;
            
//            vm.model = {
//                itemsListDeviations: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region PROCEDURE FUNCTION CALL

//            async function loadDeviations() {
//                vm.model.itemsListDeviations = await deviationsService.listDeviations({
//                    argtype: argType,
//                    argvalue: argValue
//                });
//            }

//            // #endregion PROCEDURE FUNCTION CALL

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'deviation':
//                        deviationsService.getCustactNo().then(function (response) {
//                            if (response[0]) {
//                                go({
//                                    argtype: argType,
//                                    argvalue: argValue,
//                                    custact_no_deviation: response[0].custact_no
//                                });
//                            }
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadDeviations();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
